import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../../../Providers/mainStore.slice';

const initialState = {
  passkeys: [],
  setupDialogOpen: false,
  revokeDialogOpen: false,
  passkeyToRevoke: null,
};

const passkeysSlice = createSlice({
  name: 'passkeys',
  initialState,
  reducers: {
    setPasskeysState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetPasskeysState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const { setPasskeysState, resetPasskeysState } = passkeysSlice.actions;

export default passkeysSlice.reducer;
